import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Register(){
  const [name,setName]=useState('');
  const [email,setEmail]=useState('');
  const [password,setPassword]=useState('');
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const paramRole = params.get('role');
  const [role,setRole] = useState(paramRole || 'Student');
  const [isPresetRole, setIsPresetRole] = useState(Boolean(paramRole));

  // Keep role in sync when the query string changes (fixes navigation without remount)
  useEffect(() => {
    const p = new URLSearchParams(location.search).get('role');
    if (p) {
      setRole(p);
      setIsPresetRole(true);
    } else {
      setIsPresetRole(false);
    }
  }, [location.search]);
  const [error,setError]=useState(null);
  const navigate = useNavigate();

  const handle = async (e) =>{
    e.preventDefault();
    try{
      await api.post('/auth/register', { name, email, password, role });
      navigate('/login');
    }catch(err){
      setError(err.response?.data?.message || 'Register failed');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <form onSubmit={handle} className="p-6 bg-white rounded shadow w-full max-w-md">
        <h2 className="text-2xl mb-4">Register</h2>
        {error && <div className="text-red-600 mb-2">{error}</div>}
        <input className="w-full p-2 mb-2 border" placeholder="Name" value={name} onChange={e=>setName(e.target.value)} />
        <input className="w-full p-2 mb-2 border" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} />
        <input className="w-full p-2 mb-2 border" placeholder="Password" type="password" value={password} onChange={e=>setPassword(e.target.value)} />

        {/* Show role selector only when not pre-set via query param */}
        {!isPresetRole && (
          <select className="w-full p-2 mb-2 border" value={role} onChange={e=>setRole(e.target.value)}>
            <option value="Student">Student</option>
            <option value="Manager">Manager</option>
          </select>
        )}

        <button className="w-full bg-green-600 text-white p-2 rounded">Register</button>
      </form>
    </div>
  );
}
